//ici on va faire la page de connexion et on va utiliser le formulaire pour se connecter avec l'accord du backend

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./connexion.css";
import axios from "axios";
import { API_ROUTES } from "../../utils/constant";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const Connexion = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
 

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email.trim() === "" || password.trim() === "") {
      alert("Veuillez remplir tous les champs");
    } else {
      try {
        const response = await axios.post(API_ROUTES.login, {
          email,
          password,
        });

        if (response.status === 200) {
          localStorage.setItem("token", response.data.token);
          navigate("/admin");
        } else {
          alert("Email ou mot de passe incorrect");
        }
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  return (
    <div className="connexion">
      <div> 
        <h3>
          <FontAwesomeIcon icon={faExclamationTriangle} /> Formulaire de connexion réservé aux administrateurs
        </h3>
      </div>
     
      <form className="connexion-form" onSubmit={handleSubmit}>
        <h2>Connexion</h2>
        <div className="form-control">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="form-control">
          <label htmlFor="password">Mot de passe</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button className="btn" type="submit">
          Se connecter
        </button>
      </form>
    </div>
  );
};

export default Connexion;
